import type { Config } from '@grandvisionhq/shipping'

export const getDeliveryIndicatorConfig = (): Config => ({
  inventoryChannels: {},
  missingInventoryChannelStrategy: {
    expectedDeliveryDays: '8+',
  },
})
